// import React, { useContext, useEffect, useState, useRef } from "react";
// import { useHistory } from "react-router-dom";
// import styled from "styled-components";
// import axios from "axios";
// import ModernReportForm from "../utils/DatePicker";
// import {
//   BackIcon
// } from "../../assets/icons";
// import { Sensor } from "../../assets/svg/index";
// import Banner from "../utils/banner";
// import PumpStatus from "./PumpStatus";
// import { GlobalState } from "../../GlobalState";
// import Loading from "../utils/loading";
// import SingleRangeSlider from "./SingleRangeSlider";
// import TodayReport from "../report/TodayReport";
// import WeeklyReportV2 from "../report/WeeklyReportV2";
// import moment from "moment";
// import { editAccess } from "../utils/utils";
// import MotorOnOffRuntimeTable from "../report/MotorOnOffRuntimeTable";
// import MotorWeeklyRuntimeChart from "../report/MotorWeeklyGraph";
// import MotorMonthlyRuntimeChart from "../report/MonthlyRunTimeGraph";
// import { FaDownload } from "react-icons/fa";
// import { downloadPDF } from "../utils/exportImage";
// import { CiSettings } from "react-icons/ci";
// import { FiEdit2 } from "react-icons/fi";
// import { MdClose } from "react-icons/md"

// const Container = styled.div`
//   margin: 0 auto; 
//   width: 90%;
//   padding-top: 0.5rem;

//   @media (min-width: 61.313em) {
//     width: 80%;
//   }
// `;



// const BackIconWrapper = styled.div`
//   width: 40px;
//   height: 40px;
//   border-radius: 50%;
//   cursor: pointer;
//   &:hover {
//     border: 2px solid var(--primary);
//   }
//   @media (min-width: 61.313em) {
//     width: 55px;
//     height: 55px;
//   }
// `;

// const FormWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;

//   @media (min-width: 61.313em) {
//     flex-direction: row;
//   }
// `;

// const StyledSelect = styled.select`
//   background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+)
//     no-repeat 95% 50% #fff;
//   -moz-appearance: none;
//   -webkit-appearance: none;
//   appearance: none;

//   min-width: 250px;
//   outline: none;
//   font-weight: bolder;
//   padding: 0.8rem;
//   border: 1px solid var(--text);
//   margin: 0.5rem;
//   border-radius: 30px;

//   &:focus {
//     border: 2px solid var(--primary);
//   }
// `;

// const RuntimeFormWrapper = styled.div`
// margin: 1rem;
// width: 80%;
// @media (min-width: 61.313em) {
//   width: 30%;
// }
// `
// const IconBtn = styled.button`
//   cursor: pointer;
//   color: var(--background);
//   background-color: var(--primary);
//   border: none;
//   outline: none;
//   padding: 0.5rem;
//   display: block;

//   border-radius: 30px;
//   &:disabled{
//     background-color: grey;
//   }
// `;

// const DataWrapper = styled.div`

//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;

//   @media (min-width: 61.313em) {
//   flex-direction: row;
//   align-items: center;


//   }
// `;

// const StyledInput = styled.input`
//   width: 30%;
//   // margin-top: 0.5rem;
//   margin : 0.2rem auto;
//   padding: 0.6rem;
//   font-size: 1rem;
//   background-color: #eaeaea;
//   border-radius: 10px;
//   display: flex;
//   align-items: center;
//   @media (min-width: 61.313em) {
//     width: 60%;
//   }
// `;

// const StyledTimer = styled.input`
//   background: #fff
//     no-repeat 95% 50%;
//   -moz-appearance: none;
//   -webkit-appearance: none;
//   appearance: none;

//   width: 250px;         /* same as select */
//   padding: 0.8rem 1rem;
//   font-size: 1rem;
//   border: 1px solid var(--text);
//   border-radius: 30px;
//   margin: 0.5rem 0;
//   font-weight: bold;
//   outline: none;
//   cursor: pointer;

//   &:focus {
//     border: 2px solid var(--primary);
//   }

//   @media (min-width: 61.313em) {
//     width: 250px;       /* maintain same size on larger screens */
//     margin: 0 1rem;
//   }
// `;

// const InputWrapper = styled.form`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-direction: column;
//   background-color: #fff;
//   border-radius: 10px;
//   padding: 0.3rem;
//   width: 100%;

//   @media (min-width: 61.313em) {
//    flex-direction: row;

//   }

// `;
// const StyledBtn = styled.button`
//   border: none;
//   outline: none;
//   cursor: pointer;
//   background-color: var(--primary);
//   color: var(--background);
//   padding: 0.6rem 1.3rem;
//   border-radius: 20px;
//   font-size: 1.2rem;
//   margin: 0 0.5rem;
//   text-align: center;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   &:disabled {
//     background-color: #c4c4c4;
//     cursor: not-allowed;
//   }
// `;


// const DivWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin: 1rem 0;
// `;

// const ControlsWrapper = styled.div`

//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   margin: 1rem;
//   width: 100%;
//   @media (min-width: 61.313em) {
//     width: 60%;
//   }
//  `;

// const GridLayout = styled.div`
//   display: grid;
//   grid-template-columns: 0.8fr 2.2fr; /* left (pump + motor) smaller, right (charts) larger */
//   gap: 0.5rem;
//   align-items: start;
//   margin-top: 0.2rem;
//   width: 100%;

//   @media (max-width: 1024px) {
//     grid-template-columns: 1fr; /* stack vertically on smaller screens */
//   }
// `;

// const LeftColumn = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.2rem;
//   width: 100%;
//   align-items: center;
// `;

// const RightColumn = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.2rem;
//   width: 100%;
//   overflow-x: hidden;

//   & > * {
//     width: 100%;
//     max-width: 100%;
//   }
// `;

// const HeaderWrapper = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;       
//   justify-content: flex-start;
//   gap: 0.3rem;
//   width: 100%;
//   margin-bottom: 1rem;
//   flex-wrap: nowrap;        

//   svg {
//     color: #1e40af;
//     flex-shrink: 0;          
//   }

//   span {
//     display: inline-block;   
//     // color: #1e40af;
//     font-weight: 600;
//     font-size: 0.8rem;
//     // white-space: nowrap;      /* prevents breaking text into 2 lines */
//   }
// `;

// const EditButton = styled.button`
//   background: ${props => props.isEditing ? '#ff4444' : '#5a82ff'};
//   border: none;
//   border-radius: 8px;
//   padding: 0.4rem;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: pointer;
//   transition: all 0.3s ease;

//   svg {
//     color: white;
//     font-size: 1rem;
//   }

//   &:hover {
//     background: ${props => props.isEditing ? '#cc0000' : '#4066cc'};
//     transform: scale(1.05);
//   }

//   &:disabled {
//     background: #c4c4c4;
//     cursor: not-allowed;
//     transform: none;
//   }
// `;


// export default function MotorData({ match }) {
//   const history = useHistory();
//   const state = useContext(GlobalState);
//   const [timePeriod, setTimePeriod] = useState("today");
//   const [showDatePicker, setShowDatePicker] = useState(false);
//   const [showWeekPicker, setShowWeekPicker] = useState(false);
//   const [showMonthPicker, setShowMonthPicker] = useState(false);
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [minDate, setMinDate] = useState(moment().subtract(1, 'years').format('YYYY-MM-DD'));
//   const [maxDate, setMaxDate] = useState(moment().format('YYYY-MM-DD'));
//   const [locationName, setLocationName] = useState("");
//   const [progress, setProgress] = useState(0);
//   const componentRefs = useRef({});

//   const sensor_id = match.params.sensor_id;
//   const motor_id = match.params.motor_id;
//   const sensor_type = match.params.sensor_type;

//   const [values, setValues] = useState({ start_time: "", end_time: "", runtime: "", water_limit: "" });
//   const [sensorData, setSensorData] = useState({})
//   const [isEditingOperations, setIsEditingOperations] = useState(false);

//   const [loading, setLoading] = useState(true);
//   const [motorData, setMotorData] = useState(false);

//   async function fetchData(token) {
//     try {
//       const motor = await axios.get(`${process.env.REACT_APP_API}/sensor/motor?sensor_id=${sensor_id}`, {
//         headers: { Authorization: token[0] },
//       });

//       setLoading(false);

//       if (motor.data) {
//         setValues({
//           start_time: motor?.data?.data?.preferences?.start_time,
//           end_time: motor?.data?.data?.preferences?.end_time,
//           runtime: motor?.data?.data?.runtime,
//           water_limit: motor?.data?.data?.water_limit,
//         })
//       }

//       setMotorData(motor.data);
//     } catch (err) {
//       console.log(err);
//     }
//   }

//   async function fetchSensorData(token, sensor_id) {
//     try {
//       const sensorData = await axios.get(`${process.env.REACT_APP_API}/sensor/data?sensor_id=${sensor_id}`,
//         {
//           headers: { Authorization: token[0] },
//         }
//       );
//       if (sensorData) {
//         setSensorData(sensorData.data);
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   }

//   useEffect(() => {
//     fetchSensorData(state.token, sensor_id);
//     fetchData(state.token);
//   }, [state.token]);


//   useEffect(() => {
//     if (timePeriod === "today") {
//       const today = moment().format('YYYY-MM-DD');
//       setStartDate(today);
//       setEndDate(today);
//     }
//   }, [timePeriod]);

//   useEffect(() => {
//     async function fetchMotorData(token) {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API}/sensor/motor?sensor_id=${sensor_id}`,
//           { headers: { Authorization: token[0] } }
//         );
//         const motorData = res.data?.data;
//         if (motorData) {
//           setLocationName(motorData.location_name || "");
//         }
//       } catch (error) {
//         console.error("Error fetching motor data:", error);
//       }
//     }

//     if (sensor_id) fetchMotorData(state.token);
//   }, [sensor_id, state.token]);

//   const addRef = (id, ref) => {
//     if (ref) {
//       componentRefs.current[id] = ref;
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setValues({
//       ...values,
//       [name]: value,
//     });
//   };

//   const handleOperationsEditToggle = () => {
//     if (isEditingOperations) {
//       // Cancel editing - reset to original values
//       setValues({
//         start_time: motorData?.data?.preferences?.start_time,
//         end_time: motorData?.data?.preferences?.end_time,
//         runtime: motorData?.data?.runtime,
//         water_limit: motorData?.data?.water_limit,
//       });
//     }
//     setIsEditingOperations(!isEditingOperations);
//   };



//   const submitMotorUpdate = async (e) => {
//     const { start_time, end_time, runtime, water_limit } = values;

//     if ((start_time || end_time) && (start_time > end_time)) {
//       alert("Start time cannot be greater than end time.");
//       return;
//     }

//     const res = await axios.patch(
//       `${process.env.REACT_APP_API}/sensor/motor?motor_id=${motor_id}`,
//       {
//         preferences: start_time || end_time ? {
//           start_time: start_time,
//           end_time: end_time,
//         } : undefined,
//         runtime: runtime || undefined,
//         water_limit: water_limit || undefined
//       },
//       {
//         headers: { Authorization: state.token[0] },
//       }
//     );
//     if (res.status === 200) {
//       alert("Updated successfully.");
//       setIsEditingOperations(false);
//     }
//   };

//   if (loading) return <Loading />;
//   return (
//     <Container>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           gap: "1rem",
//           width: "100%",
//         }}
//       >
//         <BackIconWrapper
//           onClick={() => history.push("/")}
//           style={{ flexShrink: 0 }}
//         >
//           <BackIcon />
//         </BackIconWrapper>

//         <div style={{ flex: 1, minWidth: 0 }}>
//           <Banner
//             // title={<>{sensor_type}</>}
//             title={"Detailed Insights !"}
//             subtitle={'Monitor motor’s performance statistics on runtime, energy usage, and cost efficiency.'}
//           >
//             <Sensor />
//           </Banner>
//         </div>
//       </div>

//       <GridLayout>
//         <LeftColumn>
//           <div
//             style={{
//               width: "100%",
//               maxWidth: "200px",
//               background: "#ffffff",
//               borderRadius: "10px",
//               boxShadow: "0 3px 8px rgba(0,0,0,0.08)",
//               padding: "0.7rem",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               gap: "0.7rem",
//             }}
//           >
//             <PumpStatus
//               isBorewell={true}
//               sensor_id={sensor_id}
//               motor_id={motor_id}
//             />

//             {motorData?.data?.isBorewell && (
//               <>
//                 <InputWrapper
//                   onSubmit={(e) => {
//                     e.preventDefault();
//                     submitMotorUpdate(e);
//                   }}
//                   style={{
//                     border: "none",
//                     borderRadius: "8px",
//                     padding: "0.3rem",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     width: "100%",
//                     boxShadow: "none",
//                     background: "transparent",
//                   }}
//                 >
//                   <HeaderWrapper style={{ justifyContent: "space-between", width: "100%" }}>
//                     <div style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
//                       <CiSettings size={26} />
//                       <span>Operation Settings</span>
//                     </div>

//                     <EditButton
//                       type="button" 
//                       onClick={handleOperationsEditToggle}
//                       disabled={!editAccess(state.userAPI)}
//                       isEditing={isEditingOperations}
//                       title={isEditingOperations ? "Cancel" : "Edit"}
//                     >
//                       {isEditingOperations ? <MdClose /> : <FiEdit2 />}
//                     </EditButton>
//                   </HeaderWrapper>

//                   {/* Input Fields */}
//                   <div
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "0.4rem",
//                       width: "100%",
//                     }}
//                   >
//                     {/* Runtime Input */}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                         background: "#fff",
//                         border: "1px solid #bfdbfe",
//                         borderRadius: "6px",
//                         padding: "0.3rem 0.4rem",
//                       }}
//                     >
//                       <label
//                         style={{
//                           display: "flex",
//                           flexDirection: "column",
//                           color: "#1e40af",
//                           fontWeight: "800",
//                           fontSize: "0.75rem",
//                           lineHeight: "1.2",
//                           minWidth: "80px",
//                           alignItems: "center",
//                         }}
//                       >
//                         ⏱️ Runtime
//                         <span style={{ color: "#64748b", fontWeight: "800", fontSize: "0.7rem", alignItems: "center" }}>
//                           (min)
//                         </span>
//                       </label>
//                       <StyledInput
//                         disabled={!isEditingOperations || !editAccess(state.userAPI)}
//                         name="runtime"
//                         placeholder="Min"
//                         value={values.runtime}
//                         onChange={handleInputChange}
//                         required
//                         min={1}
//                         max={999}
//                         type="number"
//                         style={{
//                           width: "55px",
//                           padding: "0.25rem 0.3rem",
//                           border: "1px solid #bfdbfe",
//                           borderRadius: "5px",
//                           fontSize: "0.9rem",
//                           color: "#1e40af",
//                           textAlign: "center",
//                           flexShrink: 0,
//                           background: !isEditingOperations ? "#f4f4f4" : "#fff",
//                           cursor: !isEditingOperations ? "not-allowed" : "text",
//                         }}
//                       />
//                     </div>

//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                         background: "#fff",
//                         border: "1px solid #bfdbfe",
//                         borderRadius: "6px",
//                         padding: "0.3rem 0.4rem",
//                       }}
//                     >
//                       <label
//                         style={{
//                           display: "flex",
//                           flexDirection: "column",
//                           color: "#1e40af",
//                           fontWeight: "800",
//                           fontSize: "0.75rem",
//                           lineHeight: "1.2",
//                           minWidth: "80px",
//                           alignItems: "center",
//                         }}
//                       >
//                         💧 Water Limit
//                         <span style={{ color: "#64748b", fontWeight: "800", fontSize: "0.7rem", alignItems: "center" }}>
//                           (%)
//                         </span>
//                       </label>
//                       <StyledInput
//                         disabled={!isEditingOperations || !editAccess(state.userAPI)}
//                         name="water_limit"
//                         placeholder="%"
//                         value={values.water_limit ?? motorData?.data?.water_limit ?? 45}
//                         onChange={(e) => {
//                           const value = Math.min(100, Math.max(0, parseInt(e.target.value) || 0));
//                           setValues({ ...values, water_limit: value });
//                         }}
//                         required
//                         min={0}
//                         max={100}
//                         type="number"
//                         style={{
//                           width: "55px",
//                           padding: "0.25rem 0.3rem",
//                           border: "1px solid #bfdbfe",
//                           borderRadius: "5px",
//                           fontSize: "0.9rem",
//                           color: "#1e40af",
//                           textAlign: "center",
//                           flexShrink: 0,
//                           background: !isEditingOperations ? "#f4f4f4" : "#fff",
//                           cursor: !isEditingOperations ? "not-allowed" : "text",
//                         }}
//                       />
//                     </div>
//                   </div>

//                   <div style={{ display: "flex", justifyContent: "center", width: "100%", marginTop: "0.4rem" }}>
//                     <StyledBtn
//                       disabled={!isEditingOperations || !editAccess(state.userAPI)}
//                       type="submit"
//                       style={{
//                         width: "70%",
//                         padding: "0.4rem",
//                         background: !isEditingOperations || !editAccess(state.userAPI)
//                           ? "#c4c4c4"
//                           : "linear-gradient(135deg,rgb(98, 152, 239),rgb(78, 126, 230))",
//                         color: "#fff",
//                         border: "none",
//                         borderRadius: "20px",
//                         fontSize: "0.8rem",
//                         fontWeight: "700",
//                         cursor: isEditingOperations && editAccess(state.userAPI) ? "pointer" : "not-allowed",
//                         boxShadow: isEditingOperations ? "0 2px 5px rgba(59,130,246,0.3)" : "none",
//                       }}
//                     >
//                       {!editAccess(state.userAPI) ? "🔒 No Access" : "Update"}
//                     </StyledBtn>
//                   </div>
//                 </InputWrapper>
//               </>
//             )}
//           </div>
//         </LeftColumn>

//         <RightColumn>

//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "0.6rem",
//               width: "100%",
//             }}
//           >
//             <ModernReportForm
//               timePeriod={timePeriod}
//               setTimePeriod={setTimePeriod}
//               startDate={startDate}
//               setStartDate={setStartDate}
//               endDate={endDate}
//               setEndDate={setEndDate}
//               minDate={minDate}
//               maxDate={maxDate}
//               progress={progress}
//               onDownload={async () => {
//                 const uniqueElements = Object.values(componentRefs.current).filter(
//                   (el) => el !== null && el !== undefined
//                 );

//                 if (uniqueElements.length === 0) {
//                   alert("No report available to download!");
//                   return;
//                 }

//                 console.log('Total refs:', uniqueElements.length);
//                 uniqueElements.forEach((el, idx) => {
//                   const element = el?.getElement ? el.getElement() : el;
//                   console.log(`Element ${idx}:`, element);
//                   console.log(`Element ${idx} dimensions:`, element?.offsetWidth, element?.offsetHeight);
//                 });

//                 await new Promise(resolve => setTimeout(resolve, 2000));

//                 downloadPDF(uniqueElements, setProgress);
//               }}
//               disabled={!startDate || !endDate}
//             />
//           </div>

//           {(timePeriod === "today" || timePeriod === "custom") &&
//             startDate &&
//             endDate && (
//               <MotorOnOffRuntimeTable
//                 motor_id={motor_id}
//                 ref={(el) => addRef(`today_${motor_id}`, el)}
//                 startDate={startDate}
//                 endDate={endDate}
//                 location_name={locationName}
//                 token={state.token}
//               />
//             )}

//           {timePeriod === "custom-week" && startDate && (
//             <MotorWeeklyRuntimeChart
//               ref={(el) => addRef(`weekly_${motor_id}`, el)}
//               motor_id={motor_id}
//               startDate={startDate}
//               location_name={locationName}
//               token={state.token}
//             />
//           )}

//           {timePeriod === "custom-month" && startDate && (
//             <MotorMonthlyRuntimeChart
//               motor_id={motor_id}
//               ref={(el) => addRef(`monthly_${motor_id}`, el)}
//               month={new Date(startDate).getMonth() + 1}
//               year={new Date(startDate).getFullYear()}
//               token={state.token}
//               location_name={locationName}
//             />
//           )}
//         </RightColumn>
//       </GridLayout>

//     </Container >
//   );
// }


import React, { useContext, useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import ModernReportForm from "../utils/DatePicker";
import { BackIcon } from "../../assets/icons";
import { Sensor } from "../../assets/svg/index";
import Banner from "../utils/banner";
import PumpStatus from "./PumpStatus";
import { GlobalState } from "../../GlobalState";
import Loading from "../utils/loading";
import SingleRangeSlider from "./SingleRangeSlider";
import TodayReport from "../report/TodayReport";
import WeeklyReportV2 from "../report/WeeklyReportV2";
import moment from "moment";
import { editAccess } from "../utils/utils";
import MotorOnOffRuntimeTable from "../report/MotorOnOffRuntimeTable";
import MotorWeeklyRuntimeChart from "../report/MotorWeeklyGraph";
import MotorMonthlyRuntimeChart from "../report/MonthlyRunTimeGraph";
import { FaDownload } from "react-icons/fa";
import { downloadPDF } from "../utils/exportImage";
import { CiSettings } from "react-icons/ci";
import { FiEdit2 } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { Check } from "lucide-react";

const Container = styled.div`
  margin: 0 auto;
  width: 90%;
  padding-top: 0.5rem;
  @media (min-width: 61.313em) { width: 80%; }
`;

const BackIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  &:hover { border: 2px solid var(--primary); }
  @media (min-width: 61.313em) { width: 55px; height: 55px; }
  @media (max-width: 768px) { width: 28px; height: 28px; }
`;

const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 0.8fr 2.2fr;
  gap: 0.5rem;
  align-items: start;
  margin-top: 0.2rem;
  width: 100%;
  @media (max-width: 1024px) { grid-template-columns: 1fr; }
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: 100%;
  align-items: center;
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: 100%;
  overflow-x: hidden;
  & > * { width: 100%; max-width: 100%; }
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.3rem;
  width: 100%;
  margin-bottom: 1rem;
  flex-wrap: nowrap;
  svg { color: #1e40af; flex-shrink: 0; }
  span { display: inline-block; font-weight: 600; font-size: 0.8rem; }
`;

const EditButton = styled.button`
  background: ${props => props.isEditing ? '#ff4444' : '#5a82ff'};
  border: none;
  border-radius: 8px;
  padding: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  svg { color: white; font-size: 1rem; }
  &:hover {
    background: ${props => props.isEditing ? '#cc0000' : '#4066cc'};
    transform: scale(1.05);
  }
  &:disabled { background: #c4c4c4; cursor: not-allowed; transform: none; }
`;

const InputWrapper = styled.form`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  padding: 0.3rem;
  width: 100%;
  @media (min-width: 61.313em) { flex-direction: row; }
`;

const StyledInput = styled.input`
  width: 30%;
  margin: 0.2rem auto;
  padding: 0.6rem;
  font-size: 1rem;
  background-color: #eaeaea;
  border-radius: 10px;
  display: flex;
  align-items: center;
  @media (min-width: 61.313em) { width: 60%; }
`;

const StyledBtn = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  background-color: var(--primary);
  color: var(--background);
  padding: 0.6rem 1.3rem;
  border-radius: 20px;
  font-size: 1.2rem;
  margin: 0 0.5rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  &:disabled { background-color: #c4c4c4; cursor: not-allowed; }
`;

/* ── Desktop card — hidden on mobile ── */
const DesktopCard = styled.div`
  width: 100%;
  max-width: 200px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 3px 8px rgba(0,0,0,0.08);
  padding: 0.7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.7rem;
  @media (max-width: 1024px) { display: none; }
`;

const MobileStatusRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;   /* ← center */
  gap: 0.5rem;
  width: 100%;
`;

const MobileDivider = styled.div`
  width: 100%;
  height: 1px;
  background: #f1f5f9;
`;

const MobileOpsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const MobileUpdateBtn = styled.button`
  background: ${({ disabled }) => disabled
    ? "#c4c4c4"
    : "linear-gradient(135deg, rgb(98,152,239), rgb(78,126,230))"};
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.32rem 0.7rem;
  font-size: 0.7rem;
  font-weight: 700;
  cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
  white-space: nowrap;
  flex-shrink: 0;
  align-self: stretch;
  display: flex;
  align-items: center;
  box-shadow: ${({ disabled }) => disabled ? "none" : "0 2px 5px rgba(59,130,246,0.3)"};
`;

const MobileCard = styled.div`
  display: none;
  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.09);
    overflow: hidden;
    width: 100%;
    /* Check for $isBorewell prop - use camelCase for better readability */
    max-width: ${props => props.$isBorewell ? "400px" : "250px"}; 
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0.4rem 0.6rem; /* Reduced from 0.6/0.8 to shrink white space */
    gap: 0.4rem;
  }
`;

const MobileOpsTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.85rem;      /* ← match MobileEditTitle */
  font-weight: 700;
  color: #334155;
  svg { color: #1e40af; flex-shrink: 0; }
`;

const MobileEditBtn = styled.button`
  background: ${({ isEditing }) => isEditing ? "#ff4444" : "#5a82ff"};
  border: none;
  border-radius: 7px;
  padding: 0.3rem 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  svg { color: white; font-size: 0.85rem; }
  &:disabled { background: #c4c4c4; cursor: not-allowed; }
`;

const MobileOpsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.6rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.3rem 0;
`;

const MobileInputBox = styled.div`
  width: 120px;
  flex-shrink: 0;
  border: 1px solid #cad9ef;
  border-radius: 10px;
  padding: 0.35rem 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  box-sizing: border-box;
  label {
    font-size: 0.85rem;
    font-weight: 800;
    color: #004080;
    margin: 0;
    white-space: nowrap;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.2;
    span { color: #64748b; font-size: 0.55rem; font-weight: 700; }
  }
  input {
    width: 38px;
    padding: 0.2rem 0.15rem;
    border-radius: 6px;
    border: 1px solid #ccc;
    text-align: center;
    font-size: 0.9rem;
    font-weight: 800;
    color: #1e40af;
    background: #fff;
    box-sizing: border-box;
    &:focus { border-color: #5a82ff; outline: none; }
    &:disabled { background: #f4f4f4; color: #999; cursor: not-allowed; }
  }
`;

const MobileUpdateIconBtn = styled.button`
  background: ${({ disabled }) => disabled ? "#c4c4c4" : "#5a82ff"};
  color: #fff;
  border: none;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  padding: 0;
  cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const MobileLocationName = styled.span`
  font-size: 0.85rem;
  font-weight: 900;
  color: #1e3a8a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  width: 100%;
`;

const MobileStatusBadge = styled.span`
  font-size: 0.75rem;
  font-weight: 800;
  color: ${({ on }) => on ? "#16a34a" : "#dc2626"};
  background: ${({ on }) => on ? "#dcfce7" : "#fee2e2"};
  border-radius: 6px;
  padding: 0.2rem 0.5rem;
  flex-shrink: 0;
  white-space: nowrap;
`;

const MobileHPBadge = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  color: #1e40af;
  background: #dbeafe;
  border-radius: 6px;
  padding: 0.2rem 0.5rem;
  flex-shrink: 0;
  white-space: nowrap;
`;

const SensorStatusIndicator = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LocationName = styled.p`
  margin: 0;
  font-weight: 1000;
  font-size: 0.85rem;
  text-align: center;
  word-break: break-word;    /* ← allow wrapping without overflow */
  color: ${({ $isOnline }) => ($isOnline ? '#22c55e' : '#ea580c')};
`;

const TimeElapsed = styled.div`
  font-size: 0.7rem;
  font-weight: bold;
  margin-top: 0.3rem;
  width: 100%;
  padding: 0.3rem 0.5rem;
  background: rgba(0,0,0,0.04);
  border-radius: 8px;
  box-sizing: border-box;
`;
export default function MotorData({ match }) {
  const history = useHistory();
  const state = useContext(GlobalState);
  const [timePeriod, setTimePeriod] = useState("today");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showWeekPicker, setShowWeekPicker] = useState(false);
  const [showMonthPicker, setShowMonthPicker] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [minDate, setMinDate] = useState(moment().subtract(1, 'years').format('YYYY-MM-DD'));
  const [maxDate, setMaxDate] = useState(moment().format('YYYY-MM-DD'));
  const [locationName, setLocationName] = useState("");
  const [progress, setProgress] = useState(0);
  const componentRefs = useRef({});

  const [mobilePumpOn, setMobilePumpOn] = useState(false);
  const [mobileHP, setMobileHP] = useState(null);
  const [mobileLocation, setMobileLocation] = useState("Borewell");
  const [mobileIsBorewell, setMobileIsBorewell] = useState(false);

  const sensor_id = match.params.sensor_id;
  const motor_id = match.params.motor_id;
  const sensor_type = match.params.sensor_type;

  const [values, setValues] = useState({ start_time: "", end_time: "", runtime: "", water_limit: "" });
  const [sensorData, setSensorData] = useState({});
  const [isEditingOperations, setIsEditingOperations] = useState(false);
  const [loading, setLoading] = useState(true);
  const [motorData, setMotorData] = useState(false);

  async function fetchData(token) {
    try {
      const motor = await axios.get(`${process.env.REACT_APP_API}/sensor/motor?sensor_id=${sensor_id}`, {
        headers: { Authorization: token[0] },
      });
      setLoading(false);
      if (motor.data) {
        setValues({
          start_time: motor?.data?.data?.preferences?.start_time,
          end_time: motor?.data?.data?.preferences?.end_time,
          runtime: motor?.data?.data?.runtime,
          water_limit: motor?.data?.data?.water_limit,
        });
      }
      setMotorData(motor.data);
    } catch (err) { console.log(err); }
  }

  async function fetchSensorData(token, sensor_id) {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/sensor/data?sensor_id=${sensor_id}`,
        { headers: { Authorization: token[0] } }
      );
      if (res) setSensorData(res.data);
    } catch (err) { console.log(err); }
  }

  async function fetchPumpStatusForMobile(token) {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/sensor/v2/pump_status?motor_id=${motor_id}`,
        { headers: { Authorization: token[0] } }
      );
      const d = res.data;
      setMobilePumpOn(Boolean(Number(d?.motor_status?.motor_on)));
      setMobileHP(d?.motor_status?.capacity_in_hp || null);
      setMobileLocation(d?.motor_status?.location_name || "Borewell");
      setMobileIsBorewell(!!d?.motor_status?.isBorewell);
    } catch (err) { console.log(err); }
  }

  useEffect(() => {
    fetchSensorData(state.token, sensor_id);
    fetchData(state.token);
    fetchPumpStatusForMobile(state.token);
    const interval = setInterval(() => fetchPumpStatusForMobile(state.token), 10000);
    return () => clearInterval(interval);
  }, [state.token]);

  useEffect(() => {
    if (timePeriod === "today") {
      const today = moment().format('YYYY-MM-DD');
      setStartDate(today);
      setEndDate(today);
    }
  }, [timePeriod]);

  useEffect(() => {
    async function fetchMotorData(token) {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/sensor/motor?sensor_id=${sensor_id}`,
          { headers: { Authorization: token[0] } }
        );
        const data = res.data?.data;
        if (data) setLocationName(data.location_name || "");
      } catch (error) { console.error("Error fetching motor data:", error); }
    }
    if (sensor_id) fetchMotorData(state.token);
  }, [sensor_id, state.token]);

  const addRef = (id, ref) => { if (ref) componentRefs.current[id] = ref; };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleOperationsEditToggle = () => {
    if (isEditingOperations) {
      setValues({
        start_time: motorData?.data?.preferences?.start_time,
        end_time: motorData?.data?.preferences?.end_time,
        runtime: motorData?.data?.runtime,
        water_limit: motorData?.data?.water_limit,
      });
    }
    setIsEditingOperations(!isEditingOperations);
  };

  const submitMotorUpdate = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    const { start_time, end_time, runtime, water_limit } = values;
    if ((start_time || end_time) && (start_time > end_time)) {
      alert("Start time cannot be greater than end time.");
      return;
    }
    const res = await axios.patch(
      `${process.env.REACT_APP_API}/sensor/motor?motor_id=${motor_id}`,
      {
        preferences: start_time || end_time ? { start_time, end_time } : undefined,
        runtime: runtime || undefined,
        water_limit: water_limit || undefined,
      },
      { headers: { Authorization: state.token[0] } }
    );
    if (res.status === 200) {
      alert("Updated successfully.");
      setIsEditingOperations(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <Container>
      {/* Banner */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem", width: "100%" }}>
        <BackIconWrapper onClick={() => history.push("/")} style={{ flexShrink: 0 }}>
          <BackIcon />
        </BackIconWrapper>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Banner
            title={"Detailed Insights !"}
            subtitle={"Monitor motor's performance statistics on runtime, energy usage, and cost efficiency."}
          >
            <Sensor />
          </Banner>
        </div>
      </div>

      <GridLayout>
        <LeftColumn>
          <DesktopCard>
            <PumpStatus isBorewell={true} sensor_id={sensor_id} motor_id={motor_id} />

            {motorData?.data?.isBorewell && (
              <InputWrapper
                onSubmit={(e) => { e.preventDefault(); submitMotorUpdate(e); }}
                style={{ border: "none", borderRadius: "8px", padding: "0.3rem", flexDirection: "column", alignItems: "center", width: "100%", boxShadow: "none", background: "transparent" }}
              >
                <HeaderWrapper style={{ justifyContent: "space-between", width: "100%" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
                    <CiSettings size={26} />
                    <span>Operation Settings</span>
                  </div>
                  <EditButton type="button" onClick={handleOperationsEditToggle}
                    disabled={!editAccess(state.userAPI)} isEditing={isEditingOperations}
                    title={isEditingOperations ? "Cancel" : "Edit"}>
                    {isEditingOperations ? <MdClose /> : <FiEdit2 />}
                  </EditButton>
                </HeaderWrapper>

                <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem", width: "100%" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", border: "1px solid #bfdbfe", borderRadius: "6px", padding: "0.3rem 0.4rem" }}>
                    <label style={{ display: "flex", flexDirection: "column", color: "#1e40af", fontWeight: "800", fontSize: "0.85rem", lineHeight: "1.2", minWidth: "80px", alignItems: "center" }}>
                      ⏱️ Runtime
                      <span style={{ color: "#64748b", fontWeight: "800", fontSize: "0.7rem" }}>(min)</span>
                    </label>
                    <StyledInput
                      disabled={!isEditingOperations || !editAccess(state.userAPI)}
                      name="runtime" placeholder="Min" value={values.runtime}
                      onChange={handleInputChange} required min={1} max={999} type="number"
                      style={{ width: "55px", padding: "0.25rem 0.3rem", border: "1px solid #bfdbfe", borderRadius: "5px", fontSize: "0.9rem", color: "#1e40af", textAlign: "center", flexShrink: 0, background: !isEditingOperations ? "#f4f4f4" : "#fff", cursor: !isEditingOperations ? "not-allowed" : "text" }}
                    />
                  </div>

                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", border: "1px solid #bfdbfe", borderRadius: "6px", padding: "0.3rem 0.4rem" }}>
                    <label style={{ display: "flex", flexDirection: "column", color: "#1e40af", fontWeight: "800", fontSize: "0.75rem", lineHeight: "1.2", minWidth: "80px", alignItems: "center" }}>
                      💧 Water Limit
                      <span style={{ color: "#64748b", fontWeight: "800", fontSize: "0.7rem" }}>(%)</span>
                    </label>
                    <StyledInput
                      disabled={!isEditingOperations || !editAccess(state.userAPI)}
                      name="water_limit" placeholder="%" value={values.water_limit ?? motorData?.data?.water_limit ?? 45}
                      onChange={(e) => { const v = Math.min(100, Math.max(0, parseInt(e.target.value) || 0)); setValues({ ...values, water_limit: v }); }}
                      required min={0} max={100} type="number"
                      style={{ width: "55px", padding: "0.25rem 0.3rem", border: "1px solid #bfdbfe", borderRadius: "5px", fontSize: "0.9rem", color: "#1e40af", textAlign: "center", flexShrink: 0, background: !isEditingOperations ? "#f4f4f4" : "#fff", cursor: !isEditingOperations ? "not-allowed" : "text" }}
                    />
                  </div>
                </div>

                <div style={{ display: "flex", justifyContent: "center", width: "100%", marginTop: "0.4rem" }}>
                  <StyledBtn disabled={!isEditingOperations || !editAccess(state.userAPI)} type="submit"
                    style={{ width: "70%", padding: "0.4rem", background: !isEditingOperations || !editAccess(state.userAPI) ? "#c4c4c4" : "linear-gradient(135deg,rgb(98,152,239),rgb(78,126,230))", color: "#fff", border: "none", borderRadius: "20px", fontSize: "0.8rem", fontWeight: "700", cursor: isEditingOperations && editAccess(state.userAPI) ? "pointer" : "not-allowed", boxShadow: isEditingOperations ? "0 2px 5px rgba(59,130,246,0.3)" : "none" }}>
                    {!editAccess(state.userAPI) ? "🔒 No Access" : "Update"}
                  </StyledBtn>
                </div>
              </InputWrapper>
            )}
          </DesktopCard>
          {/* <MobileCard>


            {mobileIsBorewell ? (
              <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem", width: "100%", alignItems: "center" }}>
                <MobileLocationName style={{ textAlign: "center" }}>{mobileLocation}</MobileLocationName>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.4rem" }}>
                  <MobileStatusBadge on={mobilePumpOn}>
                    {mobilePumpOn ? "● ON" : "● OFF"}
                  </MobileStatusBadge>
                  {mobileHP && (
                    <MobileHPBadge>Borewell HP: {mobileHP}</MobileHPBadge>
                  )}
                </div>
              </div>
              // ) : (
              //   <PumpStatus isBorewell={false} sensor_id={sensor_id} motor_id={motor_id} />
              // )}
            ) : (
              <div style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                padding: "0",
              }}>
                <PumpStatus isBorewell={false} sensor_id={sensor_id} motor_id={motor_id} />
              </div>
            )}

            {motorData?.data?.isBorewell && (
              <>
                <MobileDivider />
                <MobileOpsHeader>
                  <MobileOpsTitle>
                    <CiSettings size={17} />
                    <span>Operation Settings</span>
                  </MobileOpsTitle>
                  <MobileEditBtn
                    isEditing={isEditingOperations}
                    disabled={!editAccess(state.userAPI)}
                    onClick={handleOperationsEditToggle}
                  >
                    {isEditingOperations ? <MdClose /> : <FiEdit2 />}
                  </MobileEditBtn>
                </MobileOpsHeader>

                <MobileOpsRow>
                  <MobileInputBox>
                    <label>
                      Runtime
                      <span>(min)</span>
                    </label>
                    <input
                      disabled={!isEditingOperations || !editAccess(state.userAPI)}
                      name="runtime"
                      value={values.runtime}
                      onChange={handleInputChange}
                      min={1} max={999} type="number"
                    />
                  </MobileInputBox>

                  <MobileInputBox>
                    <label>
                      Water
                      <span>Limit (%)</span>
                    </label>
                    <input
                      disabled={!isEditingOperations || !editAccess(state.userAPI)}
                      name="water_limit"
                      value={values.water_limit ?? motorData?.data?.water_limit ?? 45}
                      onChange={(e) => {
                        const v = Math.min(100, Math.max(0, parseInt(e.target.value) || 0));
                        setValues({ ...values, water_limit: v });
                      }}
                      min={0} max={100} type="number"
                    />
                  </MobileInputBox>

                  <MobileUpdateIconBtn
                    disabled={!isEditingOperations || !editAccess(state.userAPI)}
                    onClick={isEditingOperations ? submitMotorUpdate : undefined}
                  >
                    <Check size={18} />
                  </MobileUpdateIconBtn>
                </MobileOpsRow>
              </>
            )}
          </MobileCard> */}

          {/* Pass the state variable here as a transient prop */}
          <MobileCard $isBorewell={mobileIsBorewell}>
            {mobileIsBorewell ? (
              <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem", width: "100%", alignItems: "center" }}>
                <MobileLocationName style={{ textAlign: "center" }}>{mobileLocation}</MobileLocationName>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.4rem" }}>
                  <MobileStatusBadge on={mobilePumpOn}>
                    {mobilePumpOn ? "● ON" : "● OFF"}
                  </MobileStatusBadge>
                  {mobileHP && (
                    <MobileHPBadge>Borewell HP: {mobileHP}</MobileHPBadge>
                  )}
                </div>
              </div>
            ) : (
              <div style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                padding: "0",
              }}>
                <PumpStatus isBorewell={false} sensor_id={sensor_id} motor_id={motor_id} />
              </div>
            )}

            {/* Settings section logic */}
            {motorData?.data?.isBorewell && (
              <>
                <MobileDivider />
                <MobileOpsHeader>
                  <MobileOpsTitle>
                    <CiSettings size={17} />
                    <span>Operation Settings</span>
                  </MobileOpsTitle>
                  <MobileEditBtn
                    isEditing={isEditingOperations}
                    disabled={!editAccess(state.userAPI)}
                    onClick={handleOperationsEditToggle}
                  >
                    {isEditingOperations ? <MdClose /> : <FiEdit2 />}
                  </MobileEditBtn>
                </MobileOpsHeader>
                <MobileOpsRow>
                  <MobileInputBox>
                    <label>
                      Runtime
                      <span>(min)</span>
                    </label>
                    <input
                      disabled={!isEditingOperations || !editAccess(state.userAPI)}
                      name="runtime"
                      value={values.runtime}
                      onChange={handleInputChange}
                      min={1} max={999} type="number"
                    />
                  </MobileInputBox>

                  <MobileInputBox>
                    <label>
                      Water
                      <span>Limit (%)</span>
                    </label>
                    <input
                      disabled={!isEditingOperations || !editAccess(state.userAPI)}
                      name="water_limit"
                      value={values.water_limit ?? motorData?.data?.water_limit ?? 45}
                      onChange={(e) => {
                        const v = Math.min(100, Math.max(0, parseInt(e.target.value) || 0));
                        setValues({ ...values, water_limit: v });
                      }}
                      min={0} max={100} type="number"
                    />
                  </MobileInputBox>

                  <MobileUpdateIconBtn
                    disabled={!isEditingOperations || !editAccess(state.userAPI)}
                    onClick={isEditingOperations ? submitMotorUpdate : undefined}
                  >
                    <Check size={18} />
                  </MobileUpdateIconBtn>
                </MobileOpsRow>
              </>
            )}
          </MobileCard>
        </LeftColumn>

        <RightColumn>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem", width: "100%" }}>
            <ModernReportForm
              timePeriod={timePeriod} setTimePeriod={setTimePeriod}
              startDate={startDate} setStartDate={setStartDate}
              endDate={endDate} setEndDate={setEndDate}
              minDate={minDate} maxDate={maxDate} progress={progress}
              onDownload={async () => {
                const uniqueElements = Object.values(componentRefs.current).filter(el => el !== null && el !== undefined);
                if (uniqueElements.length === 0) { alert("No report available to download!"); return; }
                console.log('Total refs:', uniqueElements.length);
                await new Promise(resolve => setTimeout(resolve, 2000));
                downloadPDF(uniqueElements, setProgress);
              }}
              disabled={!startDate || !endDate}
            />
          </div>

          {(timePeriod === "today" || timePeriod === "custom") && startDate && endDate && (
            <MotorOnOffRuntimeTable
              motor_id={motor_id}
              ref={(el) => addRef(`today_${motor_id}`, el)}
              startDate={startDate} endDate={endDate}
              location_name={locationName} token={state.token}
            />
          )}

          {timePeriod === "custom-week" && startDate && (
            <MotorWeeklyRuntimeChart
              ref={(el) => addRef(`weekly_${motor_id}`, el)}
              motor_id={motor_id} startDate={startDate}
              location_name={locationName} token={state.token}
            />
          )}

          {timePeriod === "custom-month" && startDate && (
            <MotorMonthlyRuntimeChart
              motor_id={motor_id}
              ref={(el) => addRef(`monthly_${motor_id}`, el)}
              month={new Date(startDate).getMonth() + 1}
              year={new Date(startDate).getFullYear()}
              token={state.token} location_name={locationName}
            />
          )}
        </RightColumn>
      </GridLayout>
    </Container>
  );
}

